import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import moment from 'moment-timezone';
import { string } from "prop-types";
import * as FileSaver from 'file-saver';

/**
 * Container component for the pharmacy page.
 * 
 */


const ClaimStatusDisplay = ({ status }) => {
    switch (status.toUpperCase()) {
        case "APPROVED":
        case "PROCESSED":
        case "PAY":
            return <div className="bold-text status-detail-label claim-approved"><span className="icon-check status-checkmark"></span>{status}</div>;
        case "CLOSED":
            return <div className="bold-text status-detail-label claim-closed">{status}</div>;
        case "ENTERED":
            return <div className="bold-text status-detail-label claim-entered">{status}</div>;
        case "IN ADJUDICATION":
            return <div className="bold-text status-detail-label claim-in-adjudication">{status}</div>;
        case "OVERPAY":
            return <div className="bold-text status-detail-label claim-overpay">{status}</div>;
        case "PENDING":
        case "PEND":
        case "IN PROCESS":
            return <div className="bold-text status-detail-label claim-pending">{status}</div>;
        case "DENIED":
        case "DENY":
        case "REJECT":
        case "REJECTED":
            return <div className="bold-text status-detail-label claim-reject"><span className="icon-error status-icon"></span>{status}</div>;
        default:
            return <div className="bold-text status-detail-label"> - </div>
    }
}

const ClaimLineStatusDisplay = ({ status }) => {
    switch (status.toUpperCase()) {
        case "APPROVED":
        case "PROCESSED":
        case "PAY":
            return <div className="bold-text status-detail-label claim-approved"><span className="icon-check status-checkmark"></span>Paid</div>;
        case "CLOSED":
            return <div className="bold-text status-detail-label claim-closed">{status}</div>;
        case "ENTERED":
            return <div className="bold-text status-detail-label claim-entered">{status}</div>;
        case "IN ADJUDICATION":
            return <div className="bold-text status-detail-label claim-in-adjudication">{status}</div>;
        case "OVERPAY":
            return <div className="bold-text status-detail-label claim-overpay">{status}</div>;
        case "PENDING":
        case "PEND":
        case "IN PROCESS":
            return <div className="bold-text status-detail-label claim-pending">Pending</div>;
        case "DENIED":
        case "DENY":
        case "REJECT":
        case "REJECTED":
            return <div className="bold-text status-detail-label claim-reject"><span className="icon-error status-icon"></span>Denied</div>;
        default:
            return <div className="bold-text status-detail-label"> - </div>
    }
}

class ClaimDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            claimLines: ["GENERAL HEALTH PANEL", "COLLECTION VENOUS BLOOD VENIPUNCTURE", "LIPID PANEL", "URNLS DIP STICK/TABLET REAGENT AUTO MICROSCOPY"],
            claimId: props.location.state.claimId,
            claimType: props.location.state.claimType, //type is not returned in Steve's claim detail call
            isEOBAvailable: props.location.state.isEOBAvailable, //isEOBAvailable is not returned in Steve's claim detail call
            memberNumber: props.location.state.memberNumber, 
            showLoader: true,
            showEobLoader: false,
            showEobErrorMessage: false,
            setEOBButton: true,
            shouldLoadData: true,
            showEOBButton: false
        };
        this.downloadEOB = this.downloadEOB.bind(this);
        this.handleEOBDownload = this.handleEOBDownload.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    componentDidMount() {
        //this.props.getClaimDetail(this.state.claimId);
        logUI("MBHWeb.UI.ClaimDetail.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, AA, swhp } = this.props;

        if (this.props.claimDetail !== prevProps.claimDetail) {
            this.setState({ showLoader: false });
            if (swhp) {
                if ((this.props.claimDetail.ClaimType && this.props.claimDetail.ClaimType.toUpperCase() !== 'MEDICAL' && this.props.claimDetail.ClaimType.toUpperCase() !== 'HOSPITAL')) {
                    this.setState({ showEOBButton: false });
                }
                else {
                    this.setState({ showEOBButton: true });
                }
            }
            else if (AA) {
                this.setState({ showEOBButton: true });
            }
            else if (hpIdentity) {
                this.setState({ showEOBButton: this.state.isEOBAvailable });
            }
        }

        if ((this.props.eobDocument !== prevProps.eobDocument || this.props.error !== prevProps.error) && this.props.claimDetail) {
            this.setState({ showEobLoader: false });
            this.handleEOBDownload();
        }

        if ((AA || hpIdentity || swhp) && this.state.shouldLoadData && !isFetching) {
            this.props.getClaimDetail(this.state.claimId);
            this.setState({ shouldLoadData: false });
        }
    }

    downloadEOB() {
        this.setState({ showEobLoader: true });
        let memId = this.props.AA ? this.props.AA : this.props.swhp ? this.props.swhp == this.state.memberNumber ? this.props.swhp : this.state.memberNumber : "";
        this.props.getEOBDocument(this.state.claimId, memId);
    }

    handleEOBDownload() {
        if (this.props.error || !this.props.eobDocument || this.props.eobDocument.status === 204) {
            this.setState({ showEobErrorMessage: true });
            return;
        }

        FileSaver.saveAs(this.props.eobDocument, "Explanation of Benefits.pdf");
    }

    goBack() {
        this.props.history.goBack();
    }

    render() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="claim-wrapper">
                            {this.state.showLoader ?
                                <div id="claim-detail-spinner" className="spinner">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                </div>
                                :
                                <div className="claim-container">
                                    <div className="row">
                                        <span className="link-text cursor-pointer" onClick={() => this.goBack()}>{'< Back'}</span>
                                    </div>
                                    <div className="hp-title">
                                        Claim Details
                                    </div>

                                    <hr></hr>

                                    <div className="row claim-base-detail">
                                        <div className="col-12 col-sm-6">
                                            <span id="claim-detail-patient-first-name" className="bold-text claim-base-label">Member:</span> {this.props.claimDetail.MemberFirstName}
                                        </div>
                                        {this.state.showEOBButton ?
                                            <div className="col-12 col-sm-6">
                                                {this.state.showEobLoader
                                                    ?
                                                    <div id="claim-detail-eob-spinner" className="spinner eob-spinner">
                                                        <div className="bounce1" />
                                                        <div className="bounce2" />
                                                        <div className="bounce3" />
                                                    </div>
                                                    :
                                                    this.state.showEobErrorMessage
                                                        ?
                                                        <span id="claim-detail-eob-status" className="bold-text entered-style"><span className="icon-input-error status-document"></span>EOB is unavailable at this time</span>
                                                        :
                                                        <span id="claim-detail-eob-status" className="bold-text link-text eob-link" onClick={() => this.downloadEOB()}><span className="icon-document status-document"></span>Explanation of Benefits</span>
                                                }
                                            </div>
                                            : ""}
                                        <div className="col-12 col-sm-6">
                                            <span id="claim-detail-start-date" className="bold-text claim-base-label">Date of Service:</span> {moment(this.props.claimDetail.DateOfService).format("MM/DD/YYYY")}
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <span id="claim-detail-claim-id" className="bold-text claim-base-label">Claim#:</span>{this.props.claimDetail.ClaimID}
                                        </div>
                                    </div>

                                    <hr></hr>

                                    <div className="row claim-status-detail">
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Statement Status</div>
                                                <ClaimStatusDisplay status={this.props.claimDetail.StatementStatus} />
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Type</div>
                                                <div id="claim-detail-claim-type" className="status-detail-label">{this.props.claimDetail && this.props.claimDetail.ClaimType === "" ? "-" : this.props.claimDetail.ClaimType}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Provider</div>
                                                <div id="claim-detail-rendering-name" className="status-detail-label">{this.props.claimDetail.ProviderName}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Provider Network</div>
                                                {this.props.AA || this.props.swhp ?                                                    
                                                    <div id="claim-detail-network-name" className="status-detail-label">{this.props.claimDetail.ProviderNetwork.trim() == "" ? "-" : this.props.claimDetail.ProviderNetwork}</div>
                                                    :
                                                    <div id="claim-detail-network-name" className="status-detail-label">{(!this.props.hpIdentity.memberUserClaims.networkName || this.props.hpIdentity.memberUserClaims.networkName.trim() == "") ? "-" : this.props.hpIdentity.memberUserClaims.networkName}</div>
                                                }
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Billed Amount</div>
                                                <div id="claim-detail-billed-amount" className="status-detail-label">{this.props.claimDetail.AmountBilled !== null ? formatter.format(this.props.claimDetail.AmountBilled) : ""}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Amount Allowed</div>
                                                <div id="claim-detail-allowed-amount" className="status-detail-label">{this.props.claimDetail.AmountAllowed !== null ? formatter.format(this.props.claimDetail.AmountAllowed) : ""}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Applied to Deductible</div>
                                                <div id="claim-detail-deductible-amount" className="status-detail-label">{this.props.claimDetail.AppliedToDeductible !== null ? formatter.format(this.props.claimDetail.AppliedToDeductible) : ""}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Applied to Co-Insurance</div>
                                                <div id="claim-detail-member-amount" className="status-detail-label">{this.props.claimDetail.AppliedToCoInsurance !== null ? formatter.format(this.props.claimDetail.AppliedToCoInsurance) : ""}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Paid by Plan</div>
                                                <div id="claim-detail-paid-amount" className="status-detail-label">{this.props.claimDetail.PaidByPlan !== null ? formatter.format(this.props.claimDetail.PaidByPlan) : ""}</div>
                                            </div>
                                        </div>
                                        {/*<div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Non-Covered</div>
                                                <div className="status-detail-label">{this.props.claimDetail.IneligibleAmount !== null ? formatter.format(this.props.claimDetail.IneligibleAmount): ""}</div>
                                            </div>
                                        </div>*/}
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Payment Status</div>
                                                <div className="status-detail-label">{!this.props.claimDetail.PaymentStatus || this.props.claimDetail.PaymentStatus.trim() == "" ? "-" : this.props.claimDetail.PaymentStatus}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row bold-text no-gutters highlighted-row amount-owed-wrapper">
                                        <div className="col-12 align-items">
                                            You May Still Owe <span id="claim-detail-owe-member-amount" className="push-right">{this.props.claimDetail.YouMayOwe !== null ? formatter.format(this.props.claimDetail.YouMayOwe) : "" }</span>
                                        </div>
                                    </div>

                                    <div className="alt-background">
                                        <div className="procedures-container">
                                            <div className="semi-bold-text procedures-title">
                                                Procedures
                                            <span className="icon-question info-hover">
                                                    <div className="info-hover-content">The Non-Covered amount is a sum of the deductibles, co-insurances, and co-pays.</div>
                                                </span>
                                            </div>

                                            {this.props.claimDetail.Procedures.map((claimLine, key) => {
                                                return (
                                                    <div key={`claim-line-${key}`} className="card">
                                                        <div className="card-header bold-text">
                                                            {claimLine.ProcedureName}
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row card-top">
                                                                <div className="col-12 col-sm-6">
                                                                    <div className="status-column">
                                                                        <div className="bold-text claim-label">Status</div>
                                                                        <ClaimLineStatusDisplay status={claimLine.Status} />
                                                                    </div>
                                                                    <hr></hr>
                                                                </div>
                                                                <div className="col-12 col-sm-6">
                                                                    <div className="status-column">
                                                                        <div className="bold-text claim-label">Paid by Plan</div>
                                                                        <div className="status-detail-label">{claimLine.PaidByPlan !== null ? formatter.format(claimLine.PaidByPlan) : ""}</div>
                                                                    </div>
                                                                    <hr></hr>
                                                                </div>
                                                                <div className="col-12 col-sm-6">
                                                                    <div className="status-column">
                                                                        <div className="bold-text claim-label">Amount Billed</div>
                                                                        <div className="status-detail-label">{claimLine.AmountBilled !== null ? formatter.format(claimLine.AmountBilled) : ""}</div>
                                                                    </div>
                                                                    <hr className="mobileOnly"></hr>
                                                                </div>
                                                                <div className="col-12 col-sm-6">
                                                                    <div className="status-column">
                                                                        <div className="bold-text claim-label">Amount Allowed</div>
                                                                        <div className="status-detail-label">{claimLine.AmountAllowed !== null ? formatter.format(claimLine.AmountAllowed) : ""}</div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row highlighted-row card-bottom">
                                                                <div className="col-12 col-sm-6">
                                                                    <div className="align-items">
                                                                        <span className="bold-text claim-label">Deductible</span><span className="push-right">{claimLine.Deductible !== null ? formatter.format(claimLine.Deductible) : ""}</span>
                                                                    </div>
                                                                    <hr></hr>
                                                                </div>
                                                                <div className="col-12 col-sm-6">
                                                                    <div className="align-items">
                                                                        <span className="bold-text claim-label">Co-Insurance</span><span className="push-right">{claimLine.Coinsurance !== null ? formatter.format(claimLine.Coinsurance) : "" }</span>
                                                                    </div>
                                                                    <hr></hr>
                                                                </div>
                                                                <div className="col-12 col-sm-6">
                                                                    <div className="align-items">
                                                                        <span className="bold-text claim-label">Copay</span><span className="push-right">{claimLine.CoPay !== null ? formatter.format(claimLine.CoPay) : "" }</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>

                                    <div className="row bold-text no-gutters highlighted-row amount-owed-wrapper">
                                        <div className="col-12 align-items">
                                            You May Still Owe <span className="push-right">{this.props.claimDetail.YouMayOwe !== null ? formatter.format(this.props.claimDetail.YouMayOwe) : ""}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        claimDetail: state.healthPlanServices.claimDetail,
        error: state.healthPlanServices.error,
        eobDocument: state.healthPlanServices.eobDocument,
        hpIdentity: state.session.healthPlanUserProfile,
        isFetching: state.healthPlanServices.isFetching,
        isEOBAvailable: state.healthPlanServices.isEOBAvailable,
        isEOBAvailableFetching: state.healthPlanServices.isEOBAvailableFetching,
        AA: state.domain.aai,
        swhp: state.domain.hi,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getClaimDetail: (claimId) => dispatch({ type: types.HP_GET_CLAIM_DETAIL_START, claimId: claimId }),
        getEOBDocument: (claimId, memId) => dispatch({ type: types.HP_GET_EOB_DOCUMENT_START, claimId: claimId, memId: memId })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClaimDetail));
